<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <!-- page Title -->
      <i-card-vertical headerTitle="교육결과" device="web">
        <template v-slot:body>
          <v-sheet class="tab-layout">
            <!-- 좌측 tab -->
            <v-card color="inner_card_bg" class="overflow-y-auto">
              <v-list class="pa-0 contents-menu">
                <v-list-item-group>
                  <v-list-item
                    v-for="(item, index) in tabList"
                    :key="item.index"
                    @click="handleTabClick(index)"
                    :class="{ active: selectedKey === index }"
                  >
                    <v-list-item-content>{{ item.name }}</v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
            <!-- 우측 테이블 영역 -->
            <!-- table -->
            <v-card class="overflow-y-auto" :class="breakpoint === 'md' || breakpoint === 'sm' || breakpoint === 'xs' ? 'mt-5' : ''">
              <div v-show="selectedKey === 0">
                <v-select
                  :value="educationKey"
                  :menu-props="{ offsetY: true }"
                  :items="eduPlanList"
                  item-text="educationNm"
                  item-value="assessmentKey"
                  class="search-select editor_bg"
                  placeholder="교육계획명"
                  solo
                  @change="handleSelectChange"
                  style="max-width: 320px"
                ></v-select>
                <!--  첫번째 테이블 -->
                <v-simple-table class="custom-table mt-5">
                  <template v-slot:default>
                    <colgroup>
                      <col width="10%" />
                      <col width="30%" />
                      <col width="10%" />
                      <col width="20%" />
                      <col width="10%" />
                      <col width="20%" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td class="text-center tableTitle">교육명</td>
                        <td class="text-left">{{ results.educationNm }}</td>
                        <td class="text-center tableTitle">교육 강사</td>
                        <td>{{ results.educationTeacher }}</td>
                        <td class="text-center tableTitle">인원</td>
                        <td class="text-right">{{ peopleCnt }}명</td>
                      </tr>
                      <tr>
                        <td class="text-center tableTitle">교육장소</td>
                        <td class="text-left" colspan="5">{{ results.educationLocation }}</td>
                      </tr>
                      <tr>
                        <td class="text-center tableTitle">교육기관</td>
                        <td class="text-left" colspan="3">{{ results.educationInstitution }}</td>
                        <td class="text-center tableTitle">교육구분</td>
                        <td>{{ results.educationDivNm }}</td>
                      </tr>
                      <tr>
                        <td class="text-center tableTitle">교육일자</td>
                        <td>{{ results.educationDt }}</td>
                        <td class="text-center tableTitle">교육시간</td>
                        <td colspan="3">{{ results.educationTimeS }} ~ {{ results.educationTimeE }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <!--  두번째 테이블 -->
                <p class="ma-0 mt-5 editor-label">교육내용</p>
                <v-textarea
                  v-model="results.educationContent"
                  auto-grow
                  solo
                  class="editor_bg"
                  readonly
                  hide-details="auto"
                  placeholder="교육 내용을 입력하세요."
                />

                <!--  세번째 테이블 -->
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <span class="ma-0 mt-5 editor-label">
                      <span>교육인원 (이수자: {{ peopleCnt }}명, 미이수자: {{ peopleNotCnt }}명)</span>
                      <v-icon small color="primary" v-on="on">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <div>{{ '이수자 : 교육참여 서명 있음, 미이수자 : 교육참여 서명 없음' }}</div>
                </v-tooltip>
                <v-simple-table class="custom-table">
                  <template v-slot:default>
                    <tbody>
                      <tr v-for="(row, index) in resultsList" :key="index" style="height: 45px">
                        <td class="text-center tableTitle">이름</td>
                        <td class="text-center">{{ row.korNm }}</td>
                        <td class="text-center tableTitle">직책</td>
                        <td class="text-center">{{ row.grpAuthNm }}</td>
                        <td class="text-center tableTitle">HP</td>
                        <td class="text-center">{{ row.hpNo }}</td>
                        <td class="text-center">
                          <img
                            v-if="row.signature != null"
                            style="padding: 0; margin: 0"
                            class="signature_display"
                            :src="row.signature"
                            width="100%"
                            height="28px"
                          />
                          <v-btn
                            v-if="row.signEducation == null && row.userCd === getUserCd()"
                            icon
                            x-small
                            color="primary"
                            @click="signEducationAction(row)"
                            ><svg-icon icon-class="card_add" class style="height: 1.65rem !important"
                          /></v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <!-- 네번째 테이블 -->
                <v-simple-table class="custom-table mt-5">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td class="text-center tableTitle">특기사항</td>
                        <td style="padding: 0 !important">
                          <v-textarea auto-grow solo hide-details="auto" ref="note" readonly v-model="results.educationNote" />
                        </td>
                        <td class="text-center tableTitle">준비사항</td>
                        <td style="padding: 0 !important">
                          <v-textarea auto-grow solo hide-details="auto" ref="note" readonly v-model="results.educationPreparations" />
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <iFileManage
                  ref="detailFileUpload_result"
                  :id="'result' + tabList[0].id"
                  :targetId="targetId"
                  targetType="00009"
                  class="mt-5"
                  @onFileChanged="onFileChanged"
                />
              </div>

              <div v-show="selectedKey === 1">
                <div class="d-flex align-center justify-space-between">
                  <v-text-field
                    class="search-text-field editor_bg"
                    placeholder="검색 내용을 입력하세요"
                    solo
                    hide-details="auto"
                    v-model="searchQuery"
                    style="max-width: 320px"
                  >
                    <template v-slot:append>
                      <svg-icon icon-class="search" style="height: 1rem !important" />
                    </template>
                  </v-text-field>
                  <date-bar
                    :firstDisplayDate="startDate"
                    :dateOnly="true"
                    class="mx-1"
                    label="조회년도"
                    year
                    full-width
                    no-title
                    @getDate="handleDateSelect"
                    style="max-width: 320px"
                  ></date-bar>
                </div>
                <!-- 교육현황 tab -->
                <v-simple-table class="mt-5 custom-table">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td class="text-center tableTitle">번호</td>
                        <td class="text-center tableTitle">이름</td>
                        <td class="text-center tableTitle">직책</td>
                        <td class="text-center tableTitle">년도</td>
                        <td class="text-center tableTitle">교육구분</td>
                        <td class="text-center tableTitle">총 교육시간(H)</td>
                        <td class="text-center tableTitle">교육건수</td>
                      </tr>
                      <tr v-for="(row, index) in filteredResults" :key="index">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td class="text-center">
                          <div class="table-cell">{{ row.korNm }}</div>
                        </td>
                        <td class="text-left">
                          <div class="table-cell">{{ row.grpAuthNm }}</div>
                        </td>
                        <td class="text-center">
                          <div class="table-cell">{{ row.writeDt }}</div>
                        </td>
                        <td class="text-center">
                          <div class="table-cell">{{ row.educationDivNm }}</div>
                        </td>
                        <td class="text-center">
                          <div class="table-cell">{{ row.educationTimeTotal }}</div>
                        </td>
                        <td class="text-center">
                          <div class="table-cell">{{ row.educationNm }}</div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <iFileManage
                  ref="detailFileUpload_current"
                  :id="'current' + tabList[0].id"
                  :targetId="targetId"
                  targetType="00019"
                  class="mt-5"
                  @onFileChanged="onFileChanged"
                />
              </div>
            </v-card>
          </v-sheet>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer v-model="procedureShow" width="75%" absolute right temporary class="feedback-area">
            <ProcedureComponent :type="'00009'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right :useBtnList="buttonUseList" @btnSearch="btnSearch()" @btnSave="btnSave()" @btnPrint="btnPrint">
          <template v-slot:body>
            <v-row no-gutters align="center" class="pa-0 pt-2" :key="test">
              <v-col cols="12" md="3" v-show="selectedKey === 0"></v-col>

              <v-col cols="12" md="4" v-show="selectedKey === 1"></v-col>
            </v-row>
          </template>
        </i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'절차서'" :icon="'file'" @click="procedureShow = !procedureShow"></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>
<script>
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import DxDateBox from 'devextreme-vue/date-box'
import notify from 'devextreme/ui/notify'
import { getCurrentDate, getPreMonth, getCurrentYear, getYearFormat } from '@/utils/common.js'

import { getExtension } from '@/utils/common.js'
//
import { AesEncrypt, AesDecrypt } from '@/utils/aes256'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import IFileUpload from '@/components/common/iFileUpload.vue'
import dateBar from '@/components/common/dateBar.vue'
import iFileManage from '@/components/esgCommon/iFileManage.vue'
import {
  getEducationResults,
  getEducationPeople,
  getEducationStatus,
  getRptEducationResults,
  getRptEducationStatus,
  signEducationPlan,
} from '@/api/leaderShip/educationResults'
import detailFileUpload from '@/components/common/detailFileUpload.vue'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'
import { getUserCd } from '@/utils/token'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    'date-bar': dateBar,
    'i-card-vertical': iCardVertical,
    iFileManage,
    // 절차서 컴포넌트
    ProcedureComponent,
  },

  data() {
    return {
      initCompId: '',
      buttonUseList: [
        'btnSearch', //조회
        'btnPrint',
        'btnSave',
      ],
      selectedKey: 0,
      educationKey: '',
      componentKey: 0,
      fileList: [],
      targetId: '',
      targetType: '00009',
      clntId: '',
      docNo: '',
      peopleCnt: 0,
      peopleNotCnt: 0,
      tabList: [
        {
          id: '0001',
          name: '교육결과',
        },
        {
          id: '0002',
          name: '교육현황',
        },
      ],
      startDate: getPreMonth(0),
      searchStartDate: getYearFormat(getPreMonth(0)),
      results: '',
      resultsList: [],
      searchQuery: '',
      resultsStatus: [],
      eduPlanList: [],
      // 사인관련
      signatureList: [
        {
          mode: 'display', //edit,display
          data: '',
          isEmpty: false,
        },
      ],
      signatureListUser: [
        // 본사 담당자 mgt_manage
        {
          // header: '서명',
          headerCd: 'signEducation',
          authList: ['ceo'],
        }, // CEO
      ],
      //비동기문제로 test 키 걸어줌
      test: 0,
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false, // 절차서 보이기
      activated: false,
    }
  },
  created() {
    // console.log('created')
    this.initCompId = this.getCompId() // 초기 페이지 진입 시 compId 세팅
  },
  activated() {
    // console.log('activated')
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
    }
    if (this.activated) {
      // mount된 상황에서 페이지 진입 후 교육계획 데이터가 존재여부 조회
      let param = {
        clntId: this.getClntId(),
        compId: this.initCompId,
      }
      this.searchResult(param)
    }
  },
  async beforeMount() {
    // console.log('beforeMount')
    let param = {
      clntId: this.getClntId(),
      compId: this.initCompId,
    }
    this.searchResult(param)
  },
  mounted() {},
  computed: {
    mobileTrigger: function () {
      return this.width < 800
    },
    filteredResults() {
      return this.resultsStatus.filter(
        (row) =>
          row.korNm.toLowerCase().includes(this.searchQuery.toLowerCase()) || row.grpAuthNm.toLowerCase().includes(this.searchQuery.toLowerCase())
      )
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name
    },
  },
  methods: {
    searchResult(param) {
      getEducationResults(param, false)
        .then((res) => {
          if (res.success) {
            if (res.list.length === 0) {
              this.vToastifyPrompt(this.$t('교육계획이 없습니다. 교육 계획 페이지로 이동합니다.'), 'info', null, null, true, 'confirm', (current) => {
                this.activated = true
                this.$router.push('/EducationPlan')
                return
              })
            }
            this.eduPlanList = res.list
            this.activated = false
            if (this.eduPlanList.length) {
              this.educationKey = this.eduPlanList[0].assessmentKey
            }
          }
        })
        .finally(() => this.btnSearch())
    },
    handleDateSelect(val) {
      if (val) {
        this.searchStartDate = val
        this.btnSearch() // btnSearch() 함수 호출
      }
    },
    forceRerender() {
      this.componentKey += 1
    },
    handleTabClick(index) {
      this.selectedKey = index
      this.btnSearch()
    },
    // handleDateChange(val) {
    //   // console.log('날짜쳉ㄴ지', val, typeof val)
    //   if (val) {
    //     this.searchStartDate = val
    //   }
    //   this.btnSearch()
    // },
    async btnSearch() {
      this.openLoading()
      if (this.selectedKey === 0) {
        // 검색을 위한 매개변수 설정
        const [clntId, compId, writeDt, docNo] = this.educationKey.split('_')
        const params = {
          clntId: clntId,
          compId: compId,
          writeDt: writeDt,
          docNo: docNo,
        }
        this.targetId = `${params.clntId}_${params.compId}_${params.writeDt}_${params.docNo}`

        // 교육 인원 처리
        getEducationPeople(params, true)
          .then((res) => {
            //파일검색
            this.$refs.detailFileUpload_result.btnSearch()
            this.results = []
            this.resultsList = []
            this.peopleCnt = 0
            this.peopleNotCnt = 0
            if (res.success) {
              if (res.list.length > 0) {
                //교육계획
                this.results = res.list[0]
                //교육인원
                this.resultsList = res.list
                // 교육 시간 형식 변환
                if (this.results.educationTimeS || this.results.educationTimeE) {
                  this.results.educationTimeS = this.results.educationTimeS.replace(/(\d{2})(\d{2})/, '$1:$2')
                  this.results.educationTimeE = this.results.educationTimeE.replace(/(\d{2})(\d{2})/, '$1:$2')
                }

                if (this.resultsList) {
                  // 미이수자
                  this.peopleNotCnt = this.resultsList.filter((item) => item.signEducation === null).length
                  this.peopleCnt = this.resultsList.length - this.peopleNotCnt
                }
              }
            }
          })
          .finally(() => this.endLoading())
      } else if (this.selectedKey === 1) {
        // 검색을 위한 매개변수 설정
        const params = {
          clntId: this.getClntId(),
          compId: this.initCompId,
          writeDt: this.searchStartDate,
        }
        this.startDate = this.searchStartDate.toString()
        this.targetId = `${params.clntId}_${params.compId}_${params.writeDt}`
        console.log('검색키', this.targetId)
        // this.startDate = this.searchStartDate
        // 교육 현황 검색
        getEducationStatus(params, true)
          .then((res) => {
            this.$refs.detailFileUpload_current.btnSearch()
            this.resultsStatus = []
            if (res.success) {
              this.resultsStatus = res.list
            }
          })
          .finally(() => this.endLoading())
      }
      this.test++
      this.endLoading()
    },
    formatDate(dateString) {
      var year = dateString.substring(0, 4)
      var month = dateString.substring(4, 6)
      var day = dateString.substring(6, 8)

      return `${year}.${month}.${day}`
    },
    changeInput() {
      console.log('검색내용입력')
    },
    handleSelectChange(value) {
      this.educationKey = value
      this.btnSearch()
    },
    btnSave() {
      if (this.selectedKey === 0) {
        console.log('결과 파일저장', this.fileList)
        // 저장 성공시 첨부 파일처리
        if (this.fileList.insert || this.fileList.delete) {
          this.$refs.detailFileUpload_result.btnSave(this.fileList)
          this.fileList = {
            insert: [],
            delete: [],
          }
        }
        this.btnSearch()
      } else if (this.selectedKey === 1) {
        console.log('현황 파일저장')
        if (this.fileList.insert || this.fileList.delete) {
          this.$refs.detailFileUpload_current.btnSave(this.fileList)
          this.fileList = {
            insert: [],
            delete: [],
          }
        }
      }
    },
    btnPrint(type) {
      if (this.selectedKey === 0) {
        if (this.resultsList.length === 0) {
          this.vSnackbar(this.$t('출력할 데이터가 없습니다.'), 'warn')
          return
        }
        const [clntId, compId, writeDt, docNo] = this.educationKey.split('_')
        let searchParams = {
          clntId: clntId,
          compId: compId,
          writeDt: writeDt,
          docNo: docNo,
          type: type,
        }
        this.openLoading()
        //PDF 출력 api
        getRptEducationResults(searchParams)
          .then((res) => {
            console.log('# res', res)
            console.log(`교육결과(${this.results.educationNm}).${type}`)
            this.downloadReport(res, `교육결과(${this.results.educationNm}).${type}`)
          })
          .catch(() => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      } else if (this.selectedKey === 1) {
        if (this.filteredResults.length === 0) {
          this.vSnackbar(this.$t('출력할 데이터가 없습니다.'), 'warn')
          return
        }
        let searchParams = {
          clntId: this.getClntId(),
          compId: this.initCompId,
          writeDt: this.searchStartDate,
          type: type,
        }
        this.openLoading()
        //PDF 출력 api
        getRptEducationStatus(searchParams)
          .then((res) => {
            this.downloadReport(res)
          })
          .catch(() => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      }
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    downloadReport(res, title = null) {
      let link = document.createElement('a')
      // 객체를 만들어서 생성
      let objectUrl = window.URL.createObjectURL(res.data)
      link.href = objectUrl
      link.download = title ? title : res.headers.filename
      link.click()
    },
    onFileChanged(fileList) {
      this.fileList = fileList
    },
    signEducationAction(row) {
      let param = {
        clntId: row.clntId,
        compId: row.compId,
        writeDt: row.writeDt.replaceAll('.', ''),
        docNo: row.docNo,
        esgHrNo: row.esgHrNo,
      }
      console.log('#param ==> ', param)
      this.openLoading()
      signEducationPlan(param, true)
        .then((res) => {
          this.btnSearch()
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.tableTitle {
  width: 10%;
}
</style>
